module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/bg_bubble_01-c6a2211886ca2b0dce4f2e52eb5bcd7d.png";